// extracted by mini-css-extract-plugin
export default {"menu_wrapper":"board-menu-picker_menu_wrapper__76-qs","menu_head":"board-menu-picker_menu_head__RlntG","menu_list_item":"board-menu-picker_menu_list_item__J2vYD"};